module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "d7e79413"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c5_r1#d6e2",
      "id": "d7e2"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 1")])]), _c('br'), _c('br'), _c('b', [_vm._v("Patriotism ")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e80213"
    }
  }, [_vm._v("Sure, I wave the American flag. Do you know a better flag to wave? Sure, I love my country with all her faults. I’m not ashamed of that, never have been, never will be.")]), _vm._v(" "), _c('p', {
    staticClass: "extr",
    attrs: {
      "id": "d7e81513"
    }
  }, [_vm._v("—John Wayne")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e82013"
    }
  }, [_c('b', [_vm._v("Are You a Patriot?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e82713"
    }
  }, [_vm._v("Are you patriotic? Most Americans would answer that question with a resounding yes! But what does it really mean to be patriotic?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e84113"
    }
  }, [_vm._v("Thomas Jefferson once told a young boy who had been named after him to “love your neighbor as yourself, and your country more than yourself.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d2",
      "id": "a2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" A patriot is someone who loves his country, who is willing to sacrifice for his country, and, yes, a patriot is someone willing to lay down his life for his country.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e87314"
    }
  }, [_vm._v("Are there many Americans nowadays who love their country so much that they are willing to make the ultimate sacrifice for its sake? Former Reagan speechwriter Peggy Noonan thinks there are—but also fears that their numbers are steadily diminishing. In a lecture to the Heritage Foundation, she observed that “we are living through the beginning of what I think is post-patriotic America. The ties that bind still exist, but they are growing frayed and tired and attenuated.” She went on to indict our educational system for no longer fostering a sense of patriotism:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e90814"
    }
  }, [_vm._v("Nobody is really teaching our children to love their country. They still pick it up from their parents, from here and there, but in general, we have dropped the ball. The schools, most of them, do not encourage patriotic feeling. Small things—so many of them do not teach the Pledge of Allegiance. Bigger things—they do not celebrate Washington’s birthday and draw pictures of him and hear stories about him as they did when we were kids. There is no Washington’s birthday; there is President’s Day, which my eleven-year-old son was once under the impression is a celebration of Bill Clinton’s birthday.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e94914"
    }
  }, [_vm._v("Beyond that, the teaching of history has changed and has been altered all out of shape. My son is instructed far more in the sins of racism than in the virtues of Abe Lincoln. There is a school in Washington—and I almost moved there so my son could attend—that actually had pictures of Washington or Lincoln on the wall. On the wall of my son’s classroom they had a big portrait of [Mexican artist] Frida Kahlo."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d3",
      "id": "a3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e98015"
    }
  }, [_vm._v("And yet, there have been moments in our recent history when we have all set aside the pseudo-sophistication of “post-patriotic America” and come together as one in defense of what conservative thinker Russell Kirk called “the Permanent Things.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e99915"
    }
  }, [_vm._v("Remember back to where you were on that horrible eleventh day of September 2001. When the news of those terrorist attacks on our country ripped the needle off the record of your day, were there any of us mourning, angry, saddened, or gripped by any of the multitude of emotions sweeping the nation who thought of ourselves as Democrats or Republicans first? As the dust cleared and the tragedy began to sink in, was there anyone not feeling a sense of pride upon hearing the news that, despite the confusion and potential danger, our government, the House of Representatives, was gaveled into session by then Congressman Porter Goss to show those responsible that they could not destroy us? The House was only in session long enough to hear this prayer from Father Gerry Creedon: “God of peace and life, send Your Spirit to heal our country. Bring consolation to all injured in today’s tragedy in New York and Washington. Protect us and help our leaders to lead us out of this moment of crisis to a new day of understanding and peace. Amen.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d4",
      "id": "a4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e105915"
    }
  }, [_vm._v("A brief session, to be sure, but our government "), _c('i', [_vm._v("was ")]), _vm._v("in session—not running, not hiding. The fact that our representatives stood tall in that moment of confusion and fear and dared to enter that building, that chamber, assumed to be yet another target under attack, sent a message to the world that we would not be shaken, we would not cower, and we will not be defeated. That swell of pride you felt and feel is patriotism.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e109216"
    }
  }, [_c('b', [_vm._v("American Exceptionalism ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e109716"
    }
  }, [_vm._v("Bred deep in the American psyche is the concept that the United States is a unique force for good in the world, a superpower that has not sought, and does not seek, to expand its borders through conquering and colonizing other lands. Secretary of State Colin Powell put it this way:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e111616"
    }
  }, [_vm._v("We have sent men and women from the armed forces of the United States to other parts of the world throughout the last century to put down oppression. We defeated fascism, we defeated communism, we saved Europe in World War One and World War Two. . . . Did we ask for any land? No, the only land we ever asked for was enough land to bury our dead. That’s the kind of nation we are."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d5",
      "id": "a5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e114416"
    }
  }, [_vm._v("But it isn’t simply our selfless actions that have made America unique; it’s our core beliefs. Heritage scholar David Azerrad observed:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e115716"
    }
  }, [_vm._v("To really understand what sets America apart, we need to examine the heart and soul of the nation: the ideas of the Declaration of Independence. Unlike other nations that derive their meaning and purpose from some unifying quality—an ethnic character, a common religion, a shared history, an ancestral land—America is a country dedicated to the universal ideas of equality and liberty. The truths we hold to be self-evident apply to "), _c('i', [_vm._v("all men—")]), _vm._v("not just to all Americans. . . . In the most fundamental sense, America is an exceptional nation not because of what it does—but because of what it "), _c('i', [_vm._v("believes")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d6",
      "id": "a6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e121017"
    }
  }, [_vm._v("Because of America’s dedication to the permanent truths expressed in the Declaration of Independence, our nation has a special responsibility to uphold the cause of liberty both at home and abroad. And while we have not always lived up to this responsibility, no nation has aspired so high and achieved so much as ours.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e123317"
    }
  }, [_vm._v("To cynical “post-patriotic” Americans, this may seem like an empty boast. Ronald Reagan’s ambassador to the United Nations, Jeane Kirkpatrick, once noted that all too many Americans have fallen into the habit of “judging ourselves by the Sermon on the Mount, and everybody else on the curve.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d7",
      "id": "a7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" But one need only look beyond oneself and try to see the world through the eyes of others—the eyes of those liberated from the oppression of Saddam Hussein or the eyes of Holocaust victims liberated by our troops—to recognize that they knew they were not trading one master for another; they were being set free.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e127217"
    }
  }, [_vm._v("In the eyes of the world, America stands for one thing above all: the promise of freedom. Even people who have never in their lives laid eyes on an American know of the promise of America, know that that promise means a better life, a life of freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e128817"
    }
  }, [_vm._v("From the moment our Founding Fathers first put ink to the parchment that is the Declaration of Independence and pledged their lives, their fortunes, and their sacred honor to create this nation, that promise has come alive. If the Revolution had failed and the massive power of the British Empire prevailed over the colonists, the signers of the Declaration of Independence would have been rounded up, tried, and executed for treason against the Crown. Their properties and private fortunes would have been expropriated, and their families would have been left penniless and disgraced. When they made the commitment to stand together and break free of British rule in the name of liberty and independence, they were literally putting their lives on the line.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e133818"
    }
  }, [_vm._v("The roots of American liberty and patriotism were planted at the very beginning of the Republic. Each generation has been supported and nourished by the sacrifices and commitments of the patriotic Americans who have gone before it. And each generation has been charged with carrying the torch of liberty passed to it, keeping that flame alive as best it could before passing the torch forward, still burning brightly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e136418"
    }
  }, [_vm._v("Subtly or overtly, each generation passes American exceptionalism to the next, be it through innovations like Henry Ford and his assembly line; or Thomas Edison and the light bulb; or Steve Jobs and the iPod, iPhone, and iPad; or through the encouraging words of parents to their children, assuring them that they can grow up to be anything they like if they put their minds to it and work hard. “Let the American youth never forget, that they possess a noble inheritance, bought by the toils, and sufferings, and blood of their ancestors,” Supreme Court Justice Joseph Story said."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d8",
      "id": "a8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" That’s a lesson for all of us to remember.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e140518"
    }
  }, [_c('b', [_vm._v("The American Dream ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e141018"
    }
  }, [_vm._v("The phrase “the American Dream” is used in many ways. When you look at the words carefully, they reveal something extraordinary. In all the history of man on earth, there has been only one country with the word "), _c('i', [_vm._v("Dream ")]), _vm._v("attached to it; there is only the American Dream. There is no French Dream or Russian Dream or Chinese Dream; there is only the American Dream, to which people from all over the world aspire and have aspired since our founding. People from 194 countries have come to America in order to participate in this dream.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e145319"
    }
  }, [_vm._v("What does the American Dream mean? Listen to what Indian-born Dinesh D’Souza told a Heritage audience in 2006:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e146319"
    }
  }, [_vm._v("If I had remained in India I would probably have lived most of my life within a five-mile radius of where I was born. I would undoubtedly have married a woman of my identical religious, socioeconomic, and cultural background. I would almost certainly have become a medical doctor, an engineer, or a software programmer . . . In sum, my destiny would, to a large degree, have been given to me.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e148919"
    }
  }, [_vm._v(". . . By coming to America, I have broken free from those traditional confines. . . . [A]t Dartmouth College . . . my reading included books like Plutarch’s "), _c('i', [_vm._v("Moralia")]), _vm._v(", "), _c('i', [_vm._v("The Federalist Papers")]), _vm._v(", and Evelyn Waugh’s "), _c('i', [_vm._v("Brideshead Revisited")]), _vm._v(". They . . . implanted in my mind ideas that I had never previously considered. By the time I graduated, I had decided to become a writer, which is something you can do in America but which is not easy to do in India.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e153319"
    }
  }, [_vm._v("After graduating . . . I became managing editor of a magazine and began writing freelance articles in newspapers. Someone in the Reagan administration was apparently impressed with my work, because I was called in for an interview and hired as a senior domestic policy analyst. I found it strange to be working in the White House, because at the time I was not a United States citizen. I am sure that such a thing would not happen in India or anywhere else in the world. I also met my future wife during that time. [H]er ancestry is English, French, Scot-Irish, and German.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e157720"
    }
  }, [_vm._v("If there is a single phrase that encapsulates life in the Third World, it is that birth is destiny. . . . In America, by contrast, your destiny is not prescribed; it is constructed.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e158820"
    }
  }, [_vm._v("Your life is like a blank sheet of paper, and you are the artist. The freedom to be the architect of your own destiny is the force behind America’s worldwide appeal. Young people, especially, find the prospect of authoring the narrative of their own lives irresistible. So the immigrant, too, soon discovers that America will enable him to break free of the constraints that have held him captive while offering the future as a landscape of his own choosing."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d9",
      "id": "a9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e162020"
    }
  }, [_vm._v("In America, people only care who you are, and they care little about your background. In America, you can start from anywhere, with or without benefits and advantages from your family, and make your own way and your own life. At any time, you can decide to change and do something completely different. Your life is yours to chart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e164320"
    }
  }, [_vm._v("The American Dream of freedom, opportunity, and financial success is available to everyone who is willing to take the time and make the effort to learn how to achieve it. The only limits on individual achievement are those placed on individuals by themselves and their imaginations.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e166521"
    }
  }, [_c('b', [_vm._v("Remembering Who We Are ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e167021"
    }
  }, [_vm._v("Jeane Kirkpatrick once said that “Americans need to face the truth about themselves, no matter how pleasant it is.” And the truth is that the United States is an exceptional nation: "), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e168321"
    }
  }, [_vm._v("• It is the world’s oldest and most stable capitalist democracy, older even than Great Britain, which did not become a mass democracy until the late nineteenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e169921"
    }
  }, [_vm._v("• It is the first nation founded in an act of rebellion against a colonial power.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e170921"
    }
  }, [_vm._v("• It is the first nation founded on the belief that the rights of man are inherent and God given, and that the powers of government derive from the consent of the governed.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e172621"
    }
  }, [_vm._v("• It is the first nation to recognize that the powers of the state must be limited to those granted by the people and to recognize explicitly that the state was founded to secure their rights.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e174221"
    }
  }, [_vm._v("• It is the first nation to be based on a separation of powers—to prevent any branch of government from gaining too much power—and the clear subordination of the military to civilian rule.")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e175821"
    }
  }, [_vm._v("• And it is the first nation to have codified all of these understandings in a Constitution that was publicly debated and democratically accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e177121"
    }
  }, [_vm._v("Other nations share in some of these traditions, but precisely because the United States was founded—whereas nations such as England and France evolved—it stands, as the British writer G. K. Chesterton pointed out, as the only country in the world based on a creed. This creed sets us apart. Nobel laureate V. S. Naipaul said, America’s creed “is an immense human idea. It cannot be reduced to a fixed system. It cannot generate fanaticism. But it is known to exist. And because of that, other more rigid systems in the end blow away.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d10",
      "id": "a10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e181022"
    }
  }, [_vm._v("American patriotism is closely linked to American exceptionalism—to the belief that America’s founding marked an immensely hopeful turning point in the history of mankind, a radically new beginning in which “common” men and women would finally come into their own and be empowered to pursue happiness in any way they saw fit, however crude or vulgar it might appear to their “betters.” On the Fourth of July, amidst the barbecues and the fireworks, the games, the sales, and the hoopla, we Americans recall our country’s founding, we renew our faith in its promise, and we offer up a silent prayer of thanks for living in this land of countless blessings and endless opportunities.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e185222"
    }
  }, [_vm._v("And just as we Americans celebrate the “immense human idea” behind our nation’s founding, so should we remember that September day when we were attacked and members of Congress stood on the steps of the Capitol and pledged unity to bring those responsible to justice. Earlier generations have recalled Pearl Harbor, the USS "), _c('i', [_vm._v("Maine")]), _vm._v(", Fort Sumter, or Lexington and Concord. Our generation will remember the night of September 11, when Republicans and Democrats, liberals and conservatives, spontaneously broke out into a chorus of “God Bless America” to show the world that despite our differences—and they are many, they are real, and they continue to this day—we are a family, we are one, and we will prevail.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e190223"
    }
  }, [_vm._v("That unity has subsequently been blurred by elections and the cut-and-thrust of politics, but patriotism and love of country live on in each of us, just below the surface. Never let us forget that day, and never let us forget that moment. And while, in the heat of political battle, we naturally focus on the differences between liberals and conservatives and their contrasting visions of our country’s future, it is important to remember that regardless of party or political philosophy, we are Americans, we love our country, and we are patriots!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d7ee476","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feul_9781595553904_epub_c7_r1.vue
// module id = 75
// module chunks = 0